(function () {
  function hasShopifyCdn(src) {
    return typeof src === "string" && src.indexOf("cdn.shopify.com/") !== -1;
  }

  function stripWidthParam(url) {
    // Remove any existing width= param cleanly, preserving other params
    var parts = url.split("?");
    if (parts.length === 1) return url;
    var base = parts[0];
    var params = parts[1].split("&").filter(function (p) {
      return p.indexOf("width=") !== 0;
    });
    return base + (params.length ? "?" + params.join("&") : "");
  }

  function withWidth(url, width) {
    var clean = stripWidthParam(url);
    return clean + (clean.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
  }

  function processImg(img) {
    if (!img || img.dataset.tvgInlineDone === "1") return;

    var src = img.getAttribute("src") || "";
    if (!hasShopifyCdn(src)) return;

    if (img.getAttribute("srcset")) return;

    img.dataset.tvgInlineDone = "1";

    img.setAttribute("loading", "lazy");
    img.setAttribute("fetchpriority", "auto");
    img.setAttribute("decoding", "async");

    // Column max is 740px. 1480 covers 2x retina. Nothing wider needed.
    var widths = [360, 540, 740, 1080, 1480];

    img.setAttribute("src", withWidth(src, 740));

    var srcset = [];
    for (var i = 0; i < widths.length; i++) {
      srcset.push(withWidth(src, widths[i]) + " " + widths[i] + "w");
    }
    img.setAttribute("srcset", srcset.join(", "));

    img.setAttribute(
      "sizes",
      "(min-width: 990px) 740px, calc(100vw - 3rem)"
    );
  }

  function run() {
    var containers = document.querySelectorAll(".article-template__content.rte");
    if (!containers.length) return;

    for (var c = 0; c < containers.length; c++) {
      var imgs = containers[c].querySelectorAll("img");
      for (var i = 0; i < imgs.length; i++) {
        processImg(imgs[i]);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();